if ("function" != typeof CartTimer) {
    class e extends HTMLElement {
        constructor() {
            super();
            var n = this
              , e = parseInt(this.dataset.time);
            let t, o, a = !1;
            localStorage.getItem("cartTimerEnd") ? (t = localStorage.getItem("cartTimerActual"),
            o = localStorage.getItem("cartTimerEnd")) : (t = (new Date).getTime(),
            o = new Date(t + 6e4 * e).getTime(),
            localStorage.setItem("cartTimerActual", t),
            localStorage.setItem("cartTimerEnd", o));
            e = () => {
                t = (new Date).getTime(),
                localStorage.setItem("cartTimerActual", t);
                var r = o - t;
                if (r < 0)
                    n.innerHTML = "<span>" + Shopify.translation.timer_ended + "</span>",
                    r < -864e5 && (localStorage.removeItem("cartTimerInitial"),
                    localStorage.removeItem("cartTimerEnd")),
                    a && clearInterval(i);
                else {
                    let e = Math.floor(r % 36e5 / 6e4)
                      , t = Math.floor(r % 6e4 / 1e3);
                    e <= 9 ? e = `0${e}` : e,
                    t <= 9 ? t = `0${t}` : t,
                    r = 0 < e ? Shopify.translation.date.m : Shopify.translation.date.minute,
                    n.querySelector(".dynamic").textContent = e + ":" + t + " " + r
                }
            }
            ;
            e(),
            a = !0;
            const i = setInterval(e, 1e3)
        }
    }
    customElements.define("cart-timer", e)
}
if ("function" != typeof Cart) {
    class e extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            var t = this;
            this.cartFooter = this.querySelector("[data-sticky-mobile]"),
            this.classList.contains("cart") && this.cartFooter && "true" == this.cartFooter.getAttribute("data-sticky-mobile") ? (document.documentElement.clientWidth < 779 ? t.setPosition() : t.unsetPosition(),
            window.on("resize", theme.utils.debounce(300, function() {
                document.documentElement.clientWidth < 779 ? t.setPosition() : t.unsetPosition()
            }))) : t.unsetPosition(),
            "true" == this.getAttribute("data-keep-on-page") && this.keepOnPage(),
            this.initListeners(),
            document.addEventListener("updateCart", function(e) {
                t.getCart()
            })
        }
        initListeners() {
            var t = this;
            window.AddCount = 0,
            this.querySelectorAll(".quantity__button").forEach(e => {
                e.addEventListener("click", function(e) {
                    e.preventDefault(),
                    e.stopPropagation(),
                    t.updateItem(this.href)
                })
            }
            ),
            this.querySelectorAll("input.quantity__input").forEach(e => {
                e.addEventListener("change", function(e) {
                    e.preventDefault(),
                    e.stopPropagation(),
                    t.updateInputItem(this)
                })
            }
            ),
            this.querySelectorAll("select.cart__selector-variant").forEach(e => {
                e.addEventListener("change", function(e) {
                    e.preventDefault(),
                    t.updateVariant(this.value, this.dataset.actual, this.dataset.quantity)
                })
            }
            )
        }
        removeListeners() {
            document.removeEventListener("updateCart", function() {
                self.getCart()
            }),
            this.querySelectorAll(".quantity__button").forEach(e => {
                e.removeEventListener("click", function(e) {
                    e.preventDefault(),
                    e.stopPropagation(),
                    self.updateItem(this.href)
                })
            }
            ),
            this.querySelectorAll("input.quantity__input").forEach(e => {
                e.removeEventListener("change", function(e) {
                    e.preventDefault(),
                    e.stopPropagation(),
                    self.updateInputItem(this)
                })
            }
            ),
            this.querySelectorAll("select.cart__selector-variant").forEach(e => {
                e.removeEventListener("change", function(e) {
                    e.preventDefault(),
                    self.updateVariant(this.value, this.dataset.actual, this.dataset.quantity)
                })
            }
            )
        }
        updateItem(e) {
            this.innerHTML += Shopify.theme_settings.loader,
            this.classList.add("loading"),
            window.ajaxURL(e).then(function() {
                document.dispatchEvent(new CustomEvent("updateCart"))
            })
        }
        updateInputItem(e) {
            this.innerHTML += Shopify.theme_settings.loader,
            this.classList.add("loading"),
            document.querySelectorAll(".cart-bubble") && document.querySelectorAll(".cart-bubble").forEach(e => {
                e.innerHTML = Shopify.theme_settings.loader
            }
            ),
            window.ajaxURL(theme.routes.cart_change_url + "?quantity=" + e.value + "&id=" + e.dataset.lineId).then(function() {
                document.dispatchEvent(new CustomEvent("updateCart"))
            })
        }
        updateVariant(e, t, r) {
            this.innerHTML += Shopify.theme_settings.loader,
            this.classList.add("loading"),
            document.querySelectorAll(".cart-bubble") && document.querySelectorAll(".cart-bubble").forEach(e => {
                e.innerHTML = Shopify.theme_settings.loader
            }
            ),
            window.ajaxURL(theme.routes.cart_change_url + "?quantity=" + r + "&id=" + t).then(function() {
                window.ajaxURL(theme.routes.cart_add_url + "?quantity=1&id=" + e).then(function() {
                    document.dispatchEvent(new CustomEvent("updateCart"))
                }).catch(e => {
                    console.error("Error:", e)
                }
                )
            }).catch(e => {
                console.error("Error:", e)
            }
            )
        }
        getCart() {
            const t = this;
            window.ajaxURL(theme.routes.cart_url).then(function(e) {
                t.renderCart(e)
            })
        }
        renderCart(e) {
            var t = this;
            let r = (new DOMParser).parseFromString(e, "text/html"), n, o;
            o = t.classList.contains("minicart-container") && !t.closest(".cart-section") ? (n = ".minicart-container",
            !0) : !(n = ".cart-section"),
            document.querySelectorAll(".cart-bubble") && document.querySelectorAll(".cart-bubble").forEach(e => {
                0 < r.querySelector(".cart-bubble").innerHTML ? (e.classList.remove("hide"),
                e.innerHTML = r.querySelector(".cart-bubble").innerHTML) : e.classList.add("hide")
            }
            ),
            document.querySelectorAll(".simple-offer-progress") && document.querySelectorAll(".simple-offer-progress").forEach(e => {
                r.querySelector(".simple-offer-progress") ? (e.innerHTML = r.querySelector(".simple-offer-progress").innerHTML) : e.remove()
            }
            ),
            r.querySelector(n + " .cart__empty") && !t.querySelector(".cart__empty") ? (t.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach(e => {
                e.classList.add("hide")
            }
            ),
            localStorage.getItem("cartTimerInitial") && (localStorage.removeItem("cartTimerInitial"),
            localStorage.removeItem("cartTimerEnd")),
            o ? t.querySelector(n + " .cart").innerHTML = r.querySelector(n + " .cart").innerHTML : t.innerHTML = r.querySelector(n + " .cart").innerHTML) : (o ? (t.querySelector(".cart__empty") ? t.querySelector(n + " .minicart-blocks").innerHTML = r.querySelector(n + " .minicart-blocks").innerHTML : t.querySelector(n + " .cart__content").innerHTML = r.querySelector(n + " .cart__content").innerHTML,
            t.querySelector(n + " .minicart-footer").innerHTML = r.querySelector(n + " .minicart-footer").innerHTML) : t.querySelector(".cart__empty") ? t.querySelector(n + " .cart__wrapper").innerHTML = r.querySelector(n + " .cart__wrapper").innerHTML : (t.querySelector(n + " .cart__content").innerHTML = r.querySelector(n + " .cart__content").innerHTML,
            t.querySelector(n + " .cart__footer:not(.added)").innerHTML = r.querySelector(n + " .cart__footer:not(.added)").innerHTML),
            t.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach(e => {
                e.classList.remove("hide")
            }
            )),
            o ? this.closest("mini-cart") && (this.closest("mini-cart").bindEvents(),
            0 < document.querySelectorAll("mini-cart").length && ("once" == Shopify.theme_settings.atc_action || "always" == Shopify.theme_settings.atc_action) && -1 == window.location.href.indexOf("cart") && (e = document.querySelector(".menu-icons mini-cart"),
            document.body.classList.remove("scroll_up"),
            document.body.classList.remove("scroll_down"),
            e.open())) : t.querySelector("product-form") && t.querySelectorAll("product-form").forEach(e => {
                const t = e.querySelector("form");
                t && t.addEventListener("submit", e.onSubmitHandler.bind(e))
            }
            ),
            t.initListeners(),
            t.querySelectorAll(".loader").forEach(e => e.remove()),
            t.classList.remove("loading"),
            t.querySelectorAll("img", "svg").forEach(e => {
                theme.utils.lazyBackgroundObserver.observe(e)
            }
            ),
            document.dispatchEvent(new CustomEvent("cartRendered"))
        }
        setPosition() {
            this.cartFooter && (this.cartFooter.closest(".cart").classList.add("added"),
            document.querySelector("footer").style.marginBottom = content.offsetHeight + "px")
        }
        unsetPosition() {
            document.querySelector("footer").style.marginBottom = "",
            this.cartFooter && this.cartFooter.closest(".cart").classList.remove("added")
        }
        keepOnPage() {
            var t = document.title
              , r = Shopify.translation.keep_on_page;
            document.addEventListener("visibilitychange", function(e) {
                !document.hidden ? document.title = t : setTimeout(function() {
                    document.title = r
                }, 300)
            })
        }
    }
    customElements.define("cart-js", e)
}
